import { render, staticRenderFns } from "./AlertProtectedTerminologies.vue?vue&type=template&id=ce467c2e&scoped=true"
import script from "./AlertProtectedTerminologies.vue?vue&type=script&lang=js"
export * from "./AlertProtectedTerminologies.vue?vue&type=script&lang=js"
import style0 from "./AlertProtectedTerminologies.vue?vue&type=style&index=0&id=ce467c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce467c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
